import React from "react";

export const ExternalLink= () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 19.5V6.5H11V5H3.5C3.22386 5 3 5.22386 3 5.5V20.5C3 20.7761 3.22386 21 3.5 21H18.5C18.7761 21 19 20.7761 19 20.5V13H17.5V19.5H4.5Z"
        fill="white"
      />
      <path
        d="M13.4697 9.54071C13.1768 9.83361 13.1768 10.3085 13.4697 10.6014C13.7626 10.8943 14.2374 10.8943 14.5303 10.6014L13.4697 9.54071ZM21.8211 2.99998C21.8211 2.58576 21.4853 2.24998 21.0711 2.24998L14.3211 2.24998C13.9069 2.24998 13.5711 2.58576 13.5711 2.99998C13.5711 3.41419 13.9069 3.74998 14.3211 3.74998H20.3211V9.74998C20.3211 10.1642 20.6569 10.5 21.0711 10.5C21.4853 10.5 21.8211 10.1642 21.8211 9.74998L21.8211 2.99998ZM14.5303 10.6014L21.6014 3.53031L20.5407 2.46965L13.4697 9.54071L14.5303 10.6014Z"
        fill="white"
      />
    </svg>
  );